/**
 * @description
 * Рендерим лейблы товара
 */

export default (handle, title) => {
  return `<div class="sticker sticker-${handle}" data-sticker-title="${title}">${title}</div>`;
};
